module.exports = __webpack_public_path__ + "static/media/cv-itziar-eng.688f9b74.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assents/cv-itziar-eng.pdf
// module id = 299
// module chunks = 0